export const LIFECYCLE_CODES = {
  ACTIVE_ACCOUNT_EXISTS: 'active_account_exists',
  ACCOUNT_REACTIVATION_REQUIRED: 'account_reactivation_required',
  ACCOUNT_DEACTIVATED: 'account_deactivated',
  ACCOUNT_SUSPENDED: 'account_suspended',
  DELETION_PENDING: 'deletion_pending',
  INVALID_OR_EXPIRED_REACTIVATION_TOKEN: 'invalid_or_expired_reactivation_token',
  SUBSCRIPTION_ACTION_REQUIRED: 'subscription_action_required',
  COMPANY_DELETION_NOT_SUPPORTED: 'company_deletion_not_supported',
}

/** Legacy backend alias — treat as a code, never as a message match. */
export const LEGACY_DELETION_PENDING_CODE = 'account_pending_deletion'

export const SIGNUP_LIFECYCLE_CODES = new Set([
  LIFECYCLE_CODES.ACTIVE_ACCOUNT_EXISTS,
  LIFECYCLE_CODES.ACCOUNT_REACTIVATION_REQUIRED,
  LIFECYCLE_CODES.ACCOUNT_DEACTIVATED,
  LIFECYCLE_CODES.DELETION_PENDING,
  LIFECYCLE_CODES.ACCOUNT_SUSPENDED,
])

export const LOGIN_LIFECYCLE_CODES = new Set([
  LIFECYCLE_CODES.ACCOUNT_REACTIVATION_REQUIRED,
  LIFECYCLE_CODES.ACCOUNT_DEACTIVATED,
  LIFECYCLE_CODES.DELETION_PENDING,
  LIFECYCLE_CODES.ACCOUNT_SUSPENDED,
])

export const KNOWN_LIFECYCLE_CODES = new Set([
  ...SIGNUP_LIFECYCLE_CODES,
  ...LOGIN_LIFECYCLE_CODES,
  LIFECYCLE_CODES.INVALID_OR_EXPIRED_REACTIVATION_TOKEN,
  LIFECYCLE_CODES.SUBSCRIPTION_ACTION_REQUIRED,
  LIFECYCLE_CODES.COMPANY_DELETION_NOT_SUPPORTED,
  LEGACY_DELETION_PENDING_CODE,
])

export const SUBSCRIPTION_ACTIONS = {
  KEEP: 'keep',
  CANCEL_AT_PERIOD_END: 'cancel_at_period_end',
  CANCEL_NOW: 'cancel_now',
}

export const LIFECYCLE_STATUSES = {
  ACTIVE: 'active',
  DEACTIVATED: 'deactivated',
  SUSPENDED: 'suspended',
  DELETION_PENDING: 'deletion_pending',
}

export const ADMIN_LIFECYCLE_ACTIONS = {
  DEACTIVATE: 'deactivate',
  REACTIVATE: 'reactivate',
  SUSPEND: 'suspend',
  UNSUSPEND: 'unsuspend',
}

export const SUPPORT_MAILTO = 'mailto:support@tech4shops.com'

export const RECOVER_SCREEN_STATES = {
  VALIDATING: 'validating',
  SUCCESS: 'success',
  EXPIRED: 'expired',
  SUSPENDED: 'suspended',
  TEMPORARY: 'temporary',
  MISSING: 'missing',
}
